import { makeStyles, Theme } from "@material-ui/core";
import { observer } from "mobx-react";
import { ConfirmDialog } from "@roc/ui";
import { useDocumentStore } from "@roc/feature-documents";

const useStyles = makeStyles((theme: Theme) => ({

}));

export const RecalculatePayoffConfirmDialog = observer(({ }) => {
  const classes = useStyles();
  const {
    documentStore: {
      documentFormStore: { payoffCalculatorStore },
    },
  } = useDocumentStore();

  return (
    <div>
      <ConfirmDialog
        open={payoffCalculatorStore.isConfirmReCalculateDialogOpen}
        confirmButtonText='Confirm'
        handleClose={() => payoffCalculatorStore.setIsConfirmReCalculateDialogOpen(false)}
        handleCancel={() => payoffCalculatorStore.setIsConfirmReCalculateDialogOpen(false)}
        handleConfirm={() => payoffCalculatorStore.payoffRecalculate()}
        title={'Re-calculate'}
        body={`This action will overwrite the current data, please confirm you want to Re-calculate.`}
      />
    </div>
  );
});
